const action = {
    general: 'Une erreur est survenue lors de l’exécution de l’action. Réessayez plus tard.',
    sign_in_identifier_changed: 'L’action ne peut pas modifier l’identifiant de connexion utilisé pour cette vérification.',
};
export default Object.freeze(action);
